import React from 'react';
import {BadgeCheckIcon} from '@heroicons/react/solid';

// Drawn inline rather than loaded from /public: each card used to request
// three icons from the app server, and when those requests failed the cards
// showed broken images with their alt text ("Verif", "lik", "vie").

const STROKE = '#636E77';

export function LikesIcon({size = 16}) {
  return (
    <svg width={size} height={size} viewBox="0 0 25 24" fill="none" aria-hidden="true" focusable="false">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 6.00093C10.7006 3.90391 7.69377 3.25583 5.43923 5.17607C3.18468 7.09631 2.86727 10.3069 4.63778 12.5779C6.10983 14.4662 10.5648 18.4486 12.0249 19.7376C12.1882 19.8818 12.2699 19.9539 12.3652 19.9822C12.4483 20.007 12.5393 20.007 12.6225 19.9822C12.7178 19.9539 12.7994 19.8818 12.9628 19.7376C14.4229 18.4486 18.8778 14.4662 20.3499 12.5779C22.1204 10.3069 21.8417 7.07611 19.5484 5.17607C17.2551 3.27603 14.2994 3.90391 12.5 6.00093Z"
        stroke={STROKE}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ViewsIcon({size = 16}) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 12" fill="none" aria-hidden="true" focusable="false">
      <path
        d="M9.99984 6.00065C9.99984 7.10522 9.10441 8.00065 7.99984 8.00065C6.89527 8.00065 5.99984 7.10522 5.99984 6.00065C5.99984 4.89608 6.89527 4.00065 7.99984 4.00065C9.10441 4.00065 9.99984 4.89608 9.99984 6.00065Z"
        stroke={STROKE}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00013 1.33398C5.01504 1.33398 2.48819 3.2959 1.63867 6.00063C2.48817 8.70538 5.01504 10.6673 8.00014 10.6673C10.9852 10.6673 13.5121 8.7054 14.3616 6.00068C13.5121 3.29593 10.9852 1.33398 8.00013 1.33398Z"
        stroke={STROKE}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Same blue as the badge it replaces (a 1024px PNG wrapped in a 73 KB SVG).
export function VerifiedBadge({size = 16}) {
  return (
    <span className="inline-flex flex-shrink-0" title="Verified">
      <BadgeCheckIcon width={size} height={size} style={{color: '#1D9BF0'}} />
      <span className="sr-only">Verified</span>
    </span>
  );
}
